/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Merge_UpInputs */

const en_shortcut_keys_name_merge_up = /** @type {(inputs: Shortcut_Keys_Name_Merge_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge Up`)
};

const fr_shortcut_keys_name_merge_up = /** @type {(inputs: Shortcut_Keys_Name_Merge_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionner vers le haut`)
};

const de_shortcut_keys_name_merge_up = /** @type {(inputs: Shortcut_Keys_Name_Merge_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenführen`)
};

const it_shortcut_keys_name_merge_up = /** @type {(inputs: Shortcut_Keys_Name_Merge_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unisci`)
};

const ru_shortcut_keys_name_merge_up = /** @type {(inputs: Shortcut_Keys_Name_Merge_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Слияние`)
};

const es_shortcut_keys_name_merge_up = /** @type {(inputs: Shortcut_Keys_Name_Merge_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusionar hacia arriba`)
};

const zh_cn2_shortcut_keys_name_merge_up = /** @type {(inputs: Shortcut_Keys_Name_Merge_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并`)
};

const ja_shortcut_keys_name_merge_up = /** @type {(inputs: Shortcut_Keys_Name_Merge_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マージアップ`)
};

const hi_shortcut_keys_name_merge_up = /** @type {(inputs: Shortcut_Keys_Name_Merge_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऊपर विलय करें`)
};

const pt_pt2_shortcut_keys_name_merge_up = /** @type {(inputs: Shortcut_Keys_Name_Merge_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fusão`)
};

/**
* | output |
* | --- |
* | "Merge Up" |
*
* @param {Shortcut_Keys_Name_Merge_UpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_merge_up = /** @type {((inputs?: Shortcut_Keys_Name_Merge_UpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Merge_UpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_merge_up(inputs)
	if (locale === "de") return de_shortcut_keys_name_merge_up(inputs)
	if (locale === "it") return it_shortcut_keys_name_merge_up(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_merge_up(inputs)
	if (locale === "es") return es_shortcut_keys_name_merge_up(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_merge_up(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_merge_up(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_merge_up(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_merge_up(inputs)
	return en_shortcut_keys_name_merge_up(inputs)
});